<template id="sortingoptions">
  <div class="">
      <!--Sorts-->
    <div class="filteroptionsModal" id="sort">
      <!-- sort desktop UI  -->
      <div class='d-flex justify-content-end margin-unset dropdown-cus' title="sort" noMaxHeight="true">
          <select class="bundle-dropdown fregular col-md-12 col-12" v-model="sortedSelection" @change="sortHandler">
              <option :checked="isDefaultSelection" :key="'sorting123'" value='DEFAULT'>Select Sorting Options</option>
              <option v-for="(item, keyindex) in sortData" :key="'sortingOp-' + keyindex + Math.floor(Math.random() * 9000) + 1000" :value="item.value">{{item.name}}</option>
          </select>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'sorting-options',
  data () {
    return {
      sortedSelection: (this.decodeFilters(this.$route.query.filters) && this.decodeFilters(this.$route.query.filters)['sort']) ? this.decodeFilters(this.$route.query.filters)['sort'] : 'DEFAULT'
    }
  },
  props: ['callerComp', 'sortData', 'sortingOptionsData'],
  // methods: {
  //   sortOptionHandler () {
  //     let filterOptions = this.$parent.$refs.filterOptions
  //     filterOptions.selectedFilters['sort'] = this.selectedSort
  //     filterOptions.applyFilters()
  //   }
  // },
  computed: {
    // selectedSort: {
    //   set (val) {
    //     let filterOptions = this.$parent.$refs.filterOptions
    //     filterOptions.selectedFilters['sort'] = val
    //     filterOptions.applyFilters()
    //   },
    //   get () {
    //     return 'PRICE_L2H'
    //   }
    // },
    isDefaultSelection () {
      return this.sortedSelection && this.sortedSelection === 'DEFAULT'
    }
  },
  methods: {
    sortHandler () {
      let filterOptions = this.$parent.$refs.filterOptions
      filterOptions.selectedFilters['sort'] = this.sortedSelection
      filterOptions.applyFilters()
    },
    decodeFilters (filters) {
      if (filters) {
        let parsedObj = {}
        for (let row of filters.split('|||')) {
          let d = row.split('||')
          if (d[0] === 'sort' || d[0] === 'gender' || d[0] === 'stock') {
            parsedObj[d[0]] = d[1]
          } else {
            parsedObj[d[0]] = d[1].split('|')
          }
        }
        return parsedObj
      }
    }
  },
  watch: {
    '$route' (to, from) {
      let filterOptions = this.decodeFilters(this.$route.query.filters)
      filterOptions && filterOptions['sort'] && filterOptions['sort'].length ? this.sortedSelection = filterOptions['sort'] : this.sortedSelection = 'DEFAULT'
    },
    sortingOptionsData () {
      if (this.sortingOptionsData && Object.keys(this.sortingOptionsData).length && this.sortingOptionsData.name && this.sortData && this.sortData.length) {
        const getSortSelection = this.sortData.filter((itm) => {
          return itm.name === this.sortingOptionsData.name
        })
        getSortSelection && getSortSelection.length ? this.sortedSelection = getSortSelection[0].value : ''
      }
    }
  }
}
</script>

<style lang="css" scoped>
.bundle-dropdown{
    padding: 4px;
    border: 1px solid #ccc;
    border-radius: 5px;
    background: #fff;
    height: 39px;
    color: #58595b;
  }
  .bundle-dropdown:focus{
    outline: none;
  }
  .dropdown-cus {
    overflow: hidden;
    position: relative;
    display: block;
    text-align: center;
  }
  .dropdown-cus::after {
    content: "\F107 ";
    font-family: FontAwesome;
    position: absolute;
    right: 5px;
    top: 5px;
    z-index: 1;
    width: 7%;
    height: 74%;
    pointer-events: none;
    font-size: 20px;
    color: #58595b;
    background: #fff;
  }
</style>



// WEBPACK FOOTER //
// sortingOptions.vue?00b10928